import gql from 'graphql-tag';
const I_KEYBOARDING_MODULE_ACTIVITY_FRAGMENT = gql `
  fragment IKeyboardingModuleActivityFragment on IKeyboardingModuleActivity {
    moduleActivityCount
    moduleActivityNumber
    scheduledActivityId
    showIntro
  }
`;
export default I_KEYBOARDING_MODULE_ACTIVITY_FRAGMENT;
